<script>
export default {
    data: () => ({
        filter: '-1',
        isEmpty: false,
        list: undefined,
        referrer: undefined
    }),
    watch: {
        filter(val) { this.updateHash(); }
    },
    created() {
        this.readHash();
        this.readReferrer();
    },
    mounted() {
        this.list = document.querySelector('.grid--qmi__list');
    },
    methods: {
        updateHash() {
            const newUrl = document.location.pathname;
            const hash = this.filter === '-1' ? '' : `#${this.filter}`;
            history.replaceState({newUrl}, '', newUrl + hash);
        },
        readHash() {
            const hash = window.location.hash;
            this.filter = hash.slice(1) || '-1';
        },
        readReferrer() {
            const referrer = document.referrer;
            if (referrer && referrer.includes('/new-home-communities/')) {
                this.referrer = referrer;
            }
        }
    }
};
</script>
